export const getCreditCard = state => state.creditCard.creditCard
export const getCreditCardLoading = state => state.creditCard.loading

export const getCreditCards = state => state.creditCards.creditCards
export const getCreditCardsLoading = state => state.creditCards.loading
export const getCreditCardsInitiated = state => state.creditCards.isInitiated
